import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import Alert from "./Alert"
import AlertDialog from "./AlertDialog"
import Button from "./Button"

export function WalletBannedDialog({
  open,
  onAbort,
  onBypass,
}: {
  open: boolean
  onAbort: () => void
  onBypass: () => void
}) {
  return (
    <AlertDialog open={open}>
      <div className="mt-4 flex flex-col items-center">
        <div className="flex size-13 items-center justify-center rounded-full bg-yellow-100">
          <ExclamationTriangleIcon className="size-6 text-yellow-600" />
        </div>
        <AlertDialog.Title className="mt-5">
          Unsupported wallet address
        </AlertDialog.Title>
        <AlertDialog.Description className="mt-2">
          For your safety, your wallet address cannot be used with this app.
        </AlertDialog.Description>

        <Alert variant="info" className="mt-5">
          Your wallet address was created before EVM support was added to NEAR.
          Please use a different wallet to continue.
        </Alert>
      </div>

      <div className="mt-5 flex flex-col gap-2">
        <Button size="xl" fullWidth onClick={onAbort} variant="primary">
          Disconnect
        </Button>
        <Button
          size="xl"
          fullWidth
          onClick={onBypass}
          variant="destructive-soft"
        >
          Proceed anyway, I know what I'm doing
        </Button>
      </div>
    </AlertDialog>
  )
}
